import { ButtonBase } from '../core/ButtonFactory';
import { ButtonInteractionProps } from '../types';
import styles from './simpleButton.module.scss';

type SimpleButtonProps = ButtonInteractionProps & {
  children: React.ReactNode;
};

export const SimpleButton = ({ children, ...props }: SimpleButtonProps) => {
  return (
    <ButtonBase className={styles.simpleButton} {...props}>
      {children}
    </ButtonBase>
  );
};
